import { ILanguageNames } from ".";

export const ENGLISH_NAMES: ILanguageNames = {
  female: [
    "Olivia",
    "Emma",
    "Charlotte",
    "Amelia",
    "Ava",
    "Sophia",
    "Isabella",
    "Mia",
    "Evelyn",
    "Harper",
    "Luna",
    "Camila",
    "Gianna",
    "Elizabeth",
    "Eleanor",
    "Ella",
    "Abigail",
    "Sofia",
    "Avery",
    "Scarlett",
    "Emily",
    "Aria",
    "Penelope",
    "Chloe",
    "Layla",
    "Lila",
    "Nora",
    "Hazel",
    "Madison",
    "Ellie",
    "Lily",
    "Nova",
    "Isla",
    "Grace",
    "Violet",
    "Aurora",
    "Riley",
    "Zoey",
    "Willow",
    "Emilia",
    "Stella",
    "Zoe",
    "Victoria",
    "Hannah",
    "Addison",
    "Leah",
    "Lucy",
    "Eliana",
    "Ivy",
    "Everly",
    "Lillian",
    "Paisley",
    "Elena",
    "Naomi",
    "Maya",
    "Natalie",
    "Kinsley",
    "Deliah",
    "Claire",
    "Audrey",
    "Aaliyah",
    "Ruby",
    "Brooklyn",
    "Alice",
    "Aubrey",
    "Autumm",
    "Leilani",
    "Savannah",
    "Valentina",
    "Kennedy",
  ],
  lastNames: [
    "Adams",
    "Allen",
    "Anderson",
    "Amstrong",
    "Atkinson",
    "Bailey",
    "Barker",
    "Barnes",
    "Bell",
    "Bennett",
    "Booth",
    "Bradley",
    "Brooks",
    "Brown",
    "Burton",
    "Butler",
    "Campbel",
    "Carter",
    "Chapman",
    "Clarke",
    "Cole",
    "Collins",
    "Cook",
    "Cooper",
    "Corbyn",
    "Cox",
    "Davidson",
    "Davies",
    "Dawson",
    "Dixon",
    "Edwards",
    "Elliott",
    "Evans",
    "Fisher",
    "Fletcher",
    "Ford",
    "Foster",
    "Fox",
    "Gibson",
    "Graham",
    "Grant",
    "Gray",
    "Green",
    "Griffiths",
    "Hall",
    "Hamilton",
    "Harris",
    "Harrison",
    "Harvey",
    "Henderson",
    "Hill",
    "Holmes",
    "Howard",
    "Hughes",
    "Hunt",
    "Hunter",
    "Jackson",
    "James",
    "Jenkins",
    "Johnson",
    "Jhonston",
    "Jones",
    "Kelly",
    "Kennedy",
    "King",
    "Knight",
    "Lawrence",
    "Lee",
  ],
  male: [
    "Noah",
    "Liam",
    "Oliver",
    "Elijah",
    "James",
    "William",
    "Benjamin",
    "Lucas",
    "Henry",
    "Theodore",
    "Jack",
    "Levi",
    "Alexander",
    "Jackson",
    "Mateo",
    "Daniel",
    "Michael",
    "Mason",
    "Sebastian",
    "Ethan",
    "Logan",
    "Owen",
    "Samuel",
    "Jacob",
    "Asher",
    "Aiden",
    "Jhon",
    "Joseph",
    "Wyatt",
    "David",
    "Leo",
    "Luke",
    "Julian",
    "Hudson",
    "Grayson",
    "Matthew",
    "Ezra",
    "Gabriel",
    "Carter",
    "Issac",
    "Jayden",
    "Luca",
    "Anthony",
    "Dylan",
    "Lincoln",
    "Thomas",
    "Maverick",
    "Elias",
    "Josiah",
    "Charles",
    "Caleb",
    "Christopher",
    "Ezekiel",
    "Miles",
    "Jaxon",
    "Isaiah",
    "Andrew",
    "Nathan",
    "Nolan",
    "Adrian",
    "Cameron",
    "Santiago",
    "Eli",
    "Aaron",
    "Ryan",
    "Cooper",
    "Waylon",
    "Easton",
  ],
};
